export default "__VITE_ASSET__CQt8py7X__"